import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  Cell,
  YAxis,
  XAxis,
  ReferenceLine,
} from "recharts";
import Heading from "./../Elements/Heading";
import { selectFormat, getAllKeys } from "./../Utils/Utils.js";
import { formatInsightText } from "./../Utils/InsightsUtils.js";

const COLORS = ["#FFCC33", "#22DB6F", "#1EBDD5"];

class ReferenceCustomLabel extends PureComponent {
  render() {
    const { total_yesterday, data_granularity } = this.props;

    return (
      <svg width="100%" height="100%">
        <text x={0} y={160} dy={0} fill={"#909CA5"} fontSize={12}>
          {data_granularity === "day" ? "Yesterday" : "Last Month"}
        </text>
        <defs>
          <filter x="0" y="0" width="1" height="1" id="solid">
            <feFlood floodColor="#88949D" />
            <feComposite in="SourceGraphic" operator="xor" />
          </filter>
        </defs>
        <text
          filter="url(#solid)"
          x={65}
          y="160"
          fontFamily="Museo Slab W01"
          fontSize="13"
        >
          &nbsp; {selectFormat(total_yesterday.type, total_yesterday.value)}{" "}
          &nbsp;
        </text>
      </svg>
    );
  }
}

class SocialChangeDetails extends PureComponent {
  static defaultProps = {
    insights: [],
    graph: [],
    total_yesterday: { type: "", value: 0 },
    data_granularity: "day",
  };

  static propTypes = {
    insights: PropTypes.array,
    graph: PropTypes.array,
    total_yesterday: PropTypes.object,
    data_granularity: PropTypes.string,
  };

  renderInsights = (type) => {
    const { insights } = this.props;
    return insights.map((insight, index) => {
      const sentiment_direction =
        insight.insight_sentiment === "positive"
          ? "up"
          : insight.insight_sentiment === "negative"
          ? "down"
          : "";

      if (type === "title" && index === 0) {
        return (
          <Heading
            size={3}
            className={"insight-summary__title mb-2"}
            key={index}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: formatInsightText(
                  insight.text_markup_array,
                  insight.text_markup
                ),
              }}
            />
          </Heading>
        );
      } else if (type === "insight" && index > 0) {
        const highlight = {
          name: "time_series",
          color: COLORS[index - 1],
        };
        return (
          <div className="mb-1" key={index}>
            <Heading
              size={5}
              className={
                "insight-summary__insight mt-3 d-flex align-items-center"
              }
              key={index}
            >
              <span
                className={
                  "metric__trend metric__trend--lg metric__trend--" +
                  sentiment_direction +
                  " mr-2"
                }
              >
                {sentiment_direction === "up" ? (
                  <React.Fragment>&#8593;</React.Fragment>
                ) : (
                  <React.Fragment>&#8595;</React.Fragment>
                )}
              </span>
              <span
                dangerouslySetInnerHTML={{
                  __html: formatInsightText(
                    insight.text_markup_array,
                    insight.text_markup,
                    highlight
                  ),
                }}
              />
            </Heading>
          </div>
        );
      } else {
        return null;
      }
    });
  };

  getSortedKeys = (_data) => {
    if (!_data || !_data[0]) return [];
    const data = _data.filter((d) => d);
    const keys = getAllKeys(data[0]);
    const len = data.length;

    return keys
      .map((key) => ({
        key: key,
        value: data.reduce((accum, curr) => accum + (curr[key] || 0), 0) / len,
      }))
      .sort((a, b) => b.value - a.value)
      .map((d) => d.key);
  };

  renderGraph = () => {
    const { graph } = this.props;
    if (!graph || graph.length === 0) return null;
    return (
      <ResponsiveContainer height={170}>
        <BarChart
          data={graph}
          layout="vertical"
          margin={{ top: 0, right: 0, left: 0, bottom: 40 }}
        >
          <XAxis type="number" dataKey="x" hide />
          <YAxis type="category" dataKey="y" hide />
          <Bar dataKey="x" fill="#8884d8" barSize={14}>
            {graph.map((entry, i) => (
              <Cell fill={COLORS[i]} key={i} />
            ))}
          </Bar>
          <ReferenceLine
            x={graph[0].y}
            stroke="#88949D"
            strokeWidth={2}
            label={<ReferenceCustomLabel {...this.props} />}
            isFront
            ifOverflow="extendDomain"
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  renderSummary = () => (
    <div className="insight-summary">
      <div className="row mb-5">
        <div className="col-12">{this.renderInsights("title")}</div>
        <div className="col-7 col-sm-7 col-md-6 col-lg-8 col-xl-8">
          {this.renderInsights("insight")}
        </div>
        <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 mt-2">
          {this.renderGraph()}
        </div>
      </div>
    </div>
  );

  render() {
    return this.renderSummary();
  }
}

export default SocialChangeDetails;
